import { ThemeOptions } from '@mui/material';
import { primary } from './colors.tsx';

declare module '@mui/material/Select' {
  interface SelectPropsVariantOverrides {
    filled: true;
    transparent: true;
  }
}
export const themeSelectOptions: ThemeOptions['components'] = {
  MuiSelect: {
    defaultProps: {
      disableUnderline: true,
    },
    styleOverrides: {
      root: {
        background: 'white',
        fontWeight: '400',
        textTransform: 'capitalize',
        color: primary.main,
        '& .MuiSelect-select': {
          borderRadius: 0,
          padding: '4px 12px 4px 12px',
          fontSize: '14px',
          border: `solid 1px ${primary.main}`,
        },
        variants: [
          {
            props: (props) => props.variant === 'filled',
            style: {
              color: primary.main,
              textAlign: 'center',
              '& .MuiSelect-filled': {
                border: 0,
                padding: '8px',
                paddingLeft: '24px',
                paddingRight: '24px',
                textAlign: 'center',
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                textTransform: 'uppercase!important',
                backgroundColor: '#F2F4F6',
                color: `${primary.main}!important`,
              },
            },
          },
        ],
      },
    },
  },
};
